import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Label, Input, Form, FormGroup, FormFeedback, Button, Card, CardBody, CardHeader } from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'; // import FacebookLogin from 'react-facebook-login'

import Layout from 'Components/Layout';
import OAuthButton from 'Components/OAuth/OAuthButton';
import { login, cleanError } from 'store/slices/authSlice';
import { setIsOpen } from 'store/slices/businessSlice';
import { validateEmail } from 'Modules/Utils';
export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      emailIsInvalid: false,
      passwordIsInvalid: false
    };
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleEmailBlur = this.handleEmailBlur.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount = () => {
    this.props.setIsOpen(false);
  };
  componentWillUnmount = () => {
    this.props.cleanError();
  };
  handlePasswordChange = event => {
    const value = event.target.value;
    this.setState({
      password: value,
      passwordIsInvalid: value.length === 0
    });
  };
  handleEmailChange = event => {
    this.setState({
      email: event.target.value
    });
  };
  handleEmailBlur = event => {// Your handleEmailBlur logic here
  };

  validate() {
    const {
      email,
      password
    } = this.state;

    if (!validateEmail(email)) {
      this.setState({
        emailIsInvalid: true
      });
      return false;
    }

    if (password.length === 0) {
      this.setState({
        passwordIsInvalid: true
      });
      return false;
    }

    return true;
  }

  submit(e) {
    e.preventDefault();

    if (!this.validate()) {
      return false;
    }

    const {
      email,
      password
    } = this.state;
    this.props.login(email, password).catch(() => {});
  }

  render() {
    const {
      email,
      password
    } = this.state;
    const {
      t,
      error,
      loading,
      isAuthenticated
    } = this.props;
    const {
      from
    } = this.props.location.state || {
      from: {
        pathname: '/'
      }
    };
    if (isAuthenticated) return <Redirect to={from} />;
    window.__LOGIN_RENDERED__ = true;
    return <Layout>
        <Helmet>
          <title>{t("Log In - HeresMyInfo.com")}</title>
        </Helmet>
        <div className="login-page">
          <Container className="py-5">
            <Row className="justify-content-center">
              <Col md="12" lg="12" xl="10">
                <Card className="login-card shadow-lg border-0">
                  <CardHeader className="text-center bg-transparent border-0 pt-4">
                    <p className="text-muted mt-2 mb-0">{t("Sign in to your account")}</p>
                  </CardHeader>
                  <CardBody className="px-4 pb-4">
                    <Form onSubmit={this.submit} onFocus={() => this.props.setIsOpen(false)}>
                      <FormGroup className="mb-3">
                        <Label for='email' className="font-weight-medium text-dark">{t("Email Address")}</Label>
                        <Input type='email' name='email' id='email' placeholder={t("Enter your email address")} value={email} invalid={this.state.emailIsInvalid} onChange={this.handleEmailChange} onBlur={this.handleEmailBlur} className="form-control-lg border-2" style={{
                        borderRadius: '8px'
                      }} />
                        <FormFeedback>{t("Please enter a valid email address.")}</FormFeedback>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <Label for='password' className="font-weight-medium text-dark mb-0">{t("Password")}</Label>
                          <Link to='/resetPassword' className="text-primary text-decoration-none small font-weight-medium">{t("Forgot password?")}</Link>
                        </div>
                        <Input type='password' name='password' id='password' placeholder={t("Enter your password")} value={password} invalid={this.state.passwordIsInvalid} onChange={this.handlePasswordChange} className="form-control-lg border-2" style={{
                        borderRadius: '8px'
                      }} />
                        <FormFeedback>{t("Please enter your password.")}</FormFeedback>
                      </FormGroup>

                      {error && <div className="alert alert-danger border-0 mb-3" style={{
                      borderRadius: '8px'
                    }}>
                          <small className="d-flex align-items-center">
                            <i className="fas fa-exclamation-triangle mr-2"></i>
                            {error.message}
                          </small>
                        </div>}

                      <Button type='submit' disabled={loading} className="btn-primary btn-lg w-100 mb-3 font-weight-medium" style={{
                      borderRadius: '8px',
                      padding: '12px',
                      fontSize: '16px',
                      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                      borderColor: '#1e3c72',
                      boxShadow: '0 3px 6px rgba(30, 60, 114, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
                    }}>
                        {loading ? <>
                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>{t("Signing In...")}</> : 'Sign In'}
                      </Button>
                    </Form>

                    <div className="text-center mb-3">
                      <div className="divider">
                        <span className="divider-text text-muted small">{t("or continue with")}</span>
                      </div>
                    </div>

                    <div className="social-login-buttons">
                      <OAuthButton provider='google' />
                      <OAuthButton provider='facebook' />
                    </div>

                    <div className="text-center mt-4">
                      <Link to="/signup" className="text-primary font-weight-medium" style={{
                      textDecoration: 'underline'
                    }}>{t("No account? Sign up here!")}</Link>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>;
  }

}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.auth.error,
  loading: state.auth.loading
});

const mapDispatchToProps = dispatch => ({
  login: (email, password) => dispatch(login(email, password)),
  cleanError: () => dispatch(cleanError()),
  setIsOpen: () => dispatch(setIsOpen(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));